import moment from "moment";
import DateRangePicker from "../../../../components/DateRangePicker";
import Layout from "../../../../components/Layout";
import { useEffect, useState } from "react";
import BackBtn from "../../../../components/BackBtn";
import { useNavigate, useParams } from "react-router-dom";
import { IoCopyOutline } from "react-icons/io5";
import {
  Button,
  Switch,
  Tabs,
  Menu,
  Dropdown,
  Tooltip,
  notification,
  Segmented,
} from "antd";
import { Outlet } from "react-router-dom";
import { IoReloadCircleOutline } from "react-icons/io5";
import { FcCalendar } from "react-icons/fc";
import { useGetCustomerMeterVendHistoryMutation } from "../../../../services/salesanalytics.services";
import VendingHistoryTable from "../../../../components/SalesAgent/Table/VendingHistoryTable";
import { useGetAllMeterCustomersMutation } from "../../../../services/customer.services";
import { CustomerMeterProfile } from "../CustomerMeterProfile";
import { useSelector } from "react-redux";
import { errorBlock } from "../../../../controllers/errorBlock";
import {
  useGetCustomerMeterDetailsMutation,
  useUnassignMeterMutation,
  useUnassignRFMeterMutation,
} from "../../../../services/meter.services";
import toast from "react-hot-toast";
import {
  useBalanceEnquiryMutation,
  useEntireMeterStateMutation,
  useGetPowerStateOfMeterMutation,
  useImmediateTurnOffMutation,
  useImmediateTurnOnMutation,
  useLastRechargeEnquiryMutation,
  useResettarrifplansonmmeterMutation,
} from "../../../../services/commands.services";
import { formatName } from "../../../../utils/helpers";
import { useMQTT } from "../../../../context/MqttContext";
import CommandModal from "../../../../components/Meter/modals/CommandModal";
import { groupedContent, metergroupedContent } from "../../../../helperFuncs";
import ScheduleConnection from "../../../../components/Commands/Modals/ScheduleConnection";
import ScheduleDisconnection from "../../../../components/Commands/Modals/ScheduleDisconnection";
import LooperTimer from "../../../../components/Commands/Modals/LoopTimer";
import ExcelExport from "../../../../components/ExportExcel";
const MeterDetails = () => {
  const [startdate, setstartdate] = useState(
    moment(Date.now()).subtract("1", "month").format("YYYY-MM-DD HH:mm:ss")
  );

  let intialCommand = {
    CON: false,
    DIS: false,
    LUP: false,
    TON: false,
    OFF: false,
  };
  const [command, setcommand] = useState(intialCommand);
  const [selectedcommand, setselectedcommand] = useState("");

  const [commandmodal, setcommandmodal] = useState(false);
  const { name: domainname } = useSelector((state) => state.domain);

  const { role, username } = useSelector((state) => state.userDetails);

  const [enddate, setenddate] = useState(
    moment(Date.now()).format("YYYY-MM-DD HH:mm:ss")
  );
  const [meterstate, setmeterstate] = useState(false);

  const { customer, meterid } = useParams();
  const { siteid, sitename } = useSelector((state) => state.projectSite);

  const [
    getPowerStateOfMeter,
    {
      isloading: powerstateloading,
      data: powerstateData,
      error: powerstateError,
    },
  ] = useGetPowerStateOfMeterMutation();

  const [
    getCustomerMeterDetails,
    { isloading: customerloading, data: customerData, error: customerError },
  ] = useGetCustomerMeterDetailsMutation();

  const [
    getCustomerMeterVendHistory,
    { isLoading: vendLoading, data: vendData, error: vendError },
  ] = useGetCustomerMeterVendHistoryMutation();

  const [
    entireMeterState,
    {
      isLoading: meterstateLoading,
      data: meterstateData,
      error: meterstateError,
    },
  ] = useEntireMeterStateMutation();

  // customer meter details
  useEffect(() => {
    try {
      getCustomerMeterDetails({
        customerid: customer,
        meter: meterid,
      }).unwrap();
    } catch (error) {
      errorBlock(error);
    }
  }, []);
  //power state of meter
  // useEffect(() => {
  //   try {
  //     getPowerStateOfMeter({
  //       meterid,
  //     })
  //       .then((res) => {
  //         if (res.error) {
  //           console.log(res.error);
  //           // errorBlock(res);
  //           return;
  //         }

  //         if (res.data.response !== "success") {
  //           notification.error({
  //             message: "Failed",
  //             description: res.data.error,
  //           });
  //           return;
  //         }
  //         // notification.success({
  //         //   message: "Success",
  //         //   description: res.data.response,
  //         // });
  //       })
  //       .catch((err) => {
  //         errorBlock(err);
  //       });
  //   } catch (error) {
  //     errorBlock(error);
  //   }
  // }, []);

  // vending call
  useEffect(() => {
    try {
      getCustomerMeterVendHistory({
        meterid,
        startdate,
        enddate,
      }).unwrap();
    } catch (error) {
      errorBlock(error);
    }
  }, [startdate, enddate]);

  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);

  const [
    unassignMeter,
    { isLoading: unassignLoading, error: unassignError, data: unassignData },
  ] = useUnassignMeterMutation();

  const [
    unassignRFMeter,
    {
      isLoading: unassignRFLoading,
      error: unassignRFError,
      data: unassignRFData,
    },
  ] = useUnassignRFMeterMutation();

  const handleUnassign = (item) => {
    // console.log(item, "item");
    if (!item?.body[0]?.meter_model)
      return notification.error({
        message: "Failed",
        description: "Can't fetch customer meter data.",
      });
    try {
      const customerMetertype = item?.body[0].meter_model.split("-")[1];
      if (customerMetertype == "RF") {
        // console.log(item);
        unassignRFMeter({
          meternumber: meterid,
          customerid: customer,
          address: item?.body[0]?.address,
          transactiontopic: `${domainname}/mqtt_${username}`,
        })
          .then((res) => {
            if (res.error) {
              errorBlock(res.error);
              return;
            }

            if (res.data.response !== "success") {
              // console.log(res.data.error);
              notification.error({
                message: "Failed",
                description: res.data.error,
              });
              return;
            }

            notification.success({
              message: "Success",
              description: "Meter was unassigned successfully",
            });
          })
          .catch((err) => {
            errorBlock(err);
          });
      } else {
        //customerMetertype == "XG";
        unassignMeter({
          meternumber: meterid,
          customerid: customer,
          address: item?.body[0]?.address,
          transactiontopic: `${domainname}/mqtt_${username}`,
        })
          .then((res) => {
            if (res.error) {
              errorBlock(res.error);
              return;
            }

            if (res.data.response !== "success") {
              // console.log(res.data.error);
              notification.error({
                message: "Failed",
                description: res.data.error || "Unable to assign meter",
              });
              return;
            }

            notification.success({
              message: "Success",
              description: "Meter was unassigned successfully",
            });
          })
          .catch((err) => {
            errorBlock(err);
          });
      }
    } catch (error) {
      errorBlock(error);
    }
  };

  const items = [
    {
      id: 1,
      label: "Customer Profile",
      link: `/meter-details/${customer}/${meterid}/customerprofile`,
    },
    {
      id: 2,
      label: "Meter Analytics",
      link: `/meter-details/${customer}/${meterid}/analytics`,
    },
    {
      id: 3,
      label: "Meter Controls",
      link: `/meter-details/${customer}/${meterid}/controls`,
    },
  ];
  const [tabstate, settabstate] = useState(1);

  const [
    balanceEnquiry,
    { isLoading: balanceLoading, data: balanceData, error: balanceError },
  ] = useBalanceEnquiryMutation();

  const [
    lastRechargeEnquiry,
    { isLoading: lenLoading, data: lenData, error: lenError },
  ] = useLastRechargeEnquiryMutation();

  const [
    resettarrifplansonmmeter,
    { isLoading: resetplanLoading, data: resetplanData, error: resetplanError },
  ] = useResettarrifplansonmmeterMutation();

  // BEN
  const handleBalance = () => {
    try {
      balanceEnquiry({
        meterid,
        transactiontopic: `${domainname}/mqtt_${username}`,
      })
        .then((res) => {
          if (res.error) {
            errorBlock(res.error);
            return;
          }

          if (res.data.response !== "success") {
            notification.error({
              message: "Failed",
              description: res.data.error,
            });
            return;
          }
          notification.success({
            message: "Success",
            description: "Request meter balance was successful",
          });
        })
        .catch((err) => {
          errorBlock(err);
        });
    } catch (error) {
      errorBlock(error);
    }
  };
  // LEN
  const handleLEN = () => {
    try {
      lastRechargeEnquiry({
        meterid,
      })
        .then((res) => {
          if (res.error) {
            errorBlock(res.error);
            return;
          }

          if (res.data.response !== "success") {
            notification.error({
              message: "Failed",
              description: res.data.error,
            });
            return;
          }
          notification.success({
            message: "Success",
            description: "Request for last recharge on meter  was successful",
          });
        })
        .catch((err) => {
          errorBlock(err);
        });
    } catch (error) {
      errorBlock(error);
    }
  };

  // RST05
  const handleResetPlan = () => {
    try {
      resettarrifplansonmmeter({
        meterid,
      })
        .then((res) => {
          if (res.error) {
            errorBlock(res.error);
            return;
          }

          if (res.data.response !== "success") {
            notification.error({
              message: "Failed",
              description: res.data.error,
            });
            return;
          }
          notification.success({
            message: "Success",
            description: "Request for clear plan on meter was successful",
          });
        })
        .catch((err) => {
          errorBlock(err);
        });
    } catch (error) {
      errorBlock(error);
    }
  };

  const [
    immediateTurnOff,
    { isLoading: offLoading, data: offData, error: offError },
  ] = useImmediateTurnOffMutation();

  const [
    immediateTurnOn,
    { isLoading: onLoading, data: onData, error: onError },
  ] = useImmediateTurnOnMutation();

  const handlePowerState = (e) => {
    try {
      if (e == false) {
        immediateTurnOff({
          meterid,
        })
          .then((res) => {
            if (res.error) {
              errorBlock(res.error);
              return;
            }

            if (res.data.response !== "success") {
              // console.log(res.data.error);
              notification.error({
                message: "Failed",
                description: res.data.error,
              });
              return;
            }

            notification.success({
              message: "Success",
              description: "Request to Turn off meter was successful",
            });
          })
          .catch((err) => {
            errorBlock(err);
          });
      } else {
        // console.log(item);
        immediateTurnOn({
          meterid,
        })
          .then((res) => {
            if (res.error) {
              errorBlock(res.error);
              return;
            }

            if (res.data.response !== "success") {
              // console.log(res.data.error);
              notification.error({
                message: "Failed",
                description: res.data.error,
              });
              return;
            }

            notification.success({
              message: "Success",
              description: "Request to Turn on meter was successful",
            });
          })
          .catch((err) => {
            errorBlock(err);
          });
      }
    } catch (error) {
      errorBlock(error);
    }
  };

  const handleGetPowerMeterState = () => {
    try {
      getPowerStateOfMeter({
        meterid,
      })
        .then((res) => {
          if (res.error) {
            errorBlock(res.error);
            return;
          }

          if (res.data.response !== "success") {
            // console.log(res.data.error);
            notification.error({
              message: "Failed",
              description: res.data.error,
            });
            return;
          }

          notification.success({
            message: "Success",
            description: res.data.response,
          });
        })
        .catch((err) => {
          errorBlock(err);
        });
    } catch (error) {
      errorBlock(error);
    }
  };
  const { message, connected } = useMQTT();
  const isCustomerManger =
    role == "Sales Agent" || role === "System Manager" ? true : false;

  // BROKER RESPONSE
  useEffect(() => {
    if (message?.deviceid == meterid) {
      if (message?.type === "GEN") {
        // console.log("Got gen with Status");
        setmeterstate(message?.status === 0 ? false : true);
      } else if (message?.type === "TON") {
        if (message?.status === "SUCCESS") {
          setmeterstate(true);
        } else {
          setmeterstate(false);
        }
      } else if (message?.type === "OFF") {
        if (message?.status === "SUCCESS") {
          setmeterstate(false);
        } else {
          setmeterstate(true);
        }
      }
    }

    return () => {};
  }, [message]);

  const dropdownMenu = (
    <Menu className="w-[200px]">
      <Menu.Item key="balance" onClick={handleBalance}>
        Request for balance
      </Menu.Item>
      <Menu.Item key="commands" onClick={handleLEN}>
        Request for Last recharge
      </Menu.Item>
      <Menu.Item key="handleResetPlan" onClick={handleResetPlan}>
        Clear balance on meter
      </Menu.Item>
    </Menu>
  );

  delete groupedContent["Reset Commands"];

  return (
    <Layout>
      <LooperTimer
        type="meter"
        setresult={false}
        setopenresult={null}
        open={command.LUP}
        intialCommand={intialCommand}
        setcommand={setcommand}
        alias={meterid}
        setOpen={() =>
          setcommand((prev) => {
            return {
              ...prev,
              LUP: false,
            };
          })
        }
        title={"this is the title"}
      />
      <ScheduleConnection
        type="meter"
        open={command.CON}
        setresult={false}
        setopenresult={null}
        alias={meterid}
        intialCommand={intialCommand}
        setcommand={setcommand}
        setOpen={() =>
          setcommand((prev) => {
            return {
              ...prev,
              CON: false,
            };
          })
        }
        title={"this is the title"}
      />
      <ScheduleDisconnection
        type="meter"
        open={command.DIS}
        setresult={false}
        setopenresult={null}
        alias={meterid}
        intialCommand={intialCommand}
        setcommand={setcommand}
        setOpen={() =>
          setcommand((prev) => {
            return {
              ...prev,
              DIS: false,
            };
          })
        }
        title={"this is the title"}
      />
      <CommandModal
        isVisible={commandmodal}
        groupedContent={metergroupedContent}
        handleCommandType={null}
        selectedcommand={selectedcommand}
        setselectedcommand={setselectedcommand}
        command={command}
        setcommand={setcommand}
        onClose={() => setcommandmodal(false)}
      />
      <div className="rounded-md ">
        <div className="bg-white rounded-sm p-2">
          <div className="flex rounded-sm px-2 items-center justify-between mb-4">
            <BackBtn text={"Go back"} />
            <div className="flex">
              {role === "Customer Manager" && (
                <div className="">
                  <Button
                    loading={unassignRFLoading || unassignLoading}
                    className="!bg-secondary !border-none !text-white"
                    type=""
                    onClick={() => handleUnassign(customerData ?? null)}
                  >
                    Unassign Meter
                  </Button>
                </div>
              )}
              <Button className="ml-3" onClick={() => setcommandmodal(true)}>
                Schedule Connection
              </Button>
            </div>
          </div>
          <div className="flex justify-between my-2">
            <div className="flex">
              <div className="h-[30px] mr-2 w-[20px] rounded bg-red-200"></div>
              <div className=" pt-1 text-[16px] ">
                Details of meter owned by{" "}
                <span className="font-semibold">
                  {customerData?.body[0]?.firstname
                    ? formatName(customerData?.body[0].firstname)
                    : ""}{" "}
                  {customerData?.body[0]?.lastname
                    ? formatName(customerData?.body[0].lastname)
                    : ""}
                  ({customer})
                </span>
                <span className="text-secondary"></span>
              </div>
            </div>

            <DateRangePicker
              setEndDate={setenddate}
              setStartDate={setstartdate}
              refreshBtn={setRefresh}
            />
          </div>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            {/* {Array.from(Array(4)).map((i, index) => ( */}
            {/* Meter number */}
            <div
              // key={index}
              className="border flex flex-col justify-between px-4 py-2 h-[130px] rounded-md"
            >
              <h1>Meter number</h1>
              <div
                onClick={() => {
                  navigator.clipboard
                    .writeText(meterid)
                    .then(() => {
                      toast.success("Meter id copied");
                    })
                    .catch((error) => {
                      console.error("Error copying text to clipboard:", error);
                    });
                }}
                className="flex text-[14px] font-light cursor-pointer items-center p-2 bg-blue-50 rounded-xl w-fit"
              >
                <h1 className=" p-0 m-0 font-semibold pr-4">{meterid}</h1>
                <div className="">
                  <IoCopyOutline />
                </div>
              </div>
              <div className="mt-2 flex items-center justify-between">
                <p className="m-0 text-[12px]">Meter model</p>
                <p className="m-0 text-[12px] font-semibold">
                  {customerData?.body[0]?.meter_model ?? ""}
                </p>
                {/* <Switch size="" checkedChildren="off" unCheckedChildren="on" /> */}
              </div>
            </div>
            {/* Power state */}
            <div className="border flex flex-col justify-between px-4 py-2 h-[130px] rounded-md">
              <div className="flex items-center justify-between">
                <h1>Power state of meter</h1>
                <Tooltip
                  title={"Get current power state"}
                  className="border-1 rounded-full cursor-pointer "
                >
                  <div
                    className=""
                    role="button"
                    onClick={handleGetPowerMeterState}
                  >
                    {meterstateLoading ? (
                      <span className="text-[10px]">loading...</span>
                    ) : (
                      <IoReloadCircleOutline size={20} color="" />
                    )}
                  </div>
                </Tooltip>
              </div>
              <div
                onClick={() => alert("Meter id copied")}
                className="flex text-[14px] font-light cursor-pointer items-center p-2 bg-green-100 rounded-full w-fit"
              >
                <h1 className=" p-0 m-0 text-green-900 font-semibold">
                  Active
                </h1>
              </div>
              <div className="mt-2 flex items-center justify-between">
                <p className="m-0 text-[12px]">Last known state of meter</p>
                {/* {meterstate} */}
                <Switch
                  onChange={handlePowerState}
                  size=""
                  checked={meterstate}
                  disabled={isCustomerManger}
                  unCheckedChildren="off"
                  checkedChildren="on"
                />
              </div>
            </div>
            {/* Update */}
            <div className="border hidden flex-col justify-between px-4 py-2 h-[130px] rounded-md">
              <h1>Update received from meter</h1>
              <div
                // onClick={() => alert("Meter id copied")}
                className="flex text-[14px] font-light cursor-pointer items-center p-2 bg-blue-50 rounded-xl w-fit"
              >
                {/* <h1 className=" p-0 m-0 font-semibold pr-4">{meterid}</h1> */}
                <div className="">
                  <IoCopyOutline />
                </div>
              </div>
              <div className="mt-2 flex items-center justify-between">
                <p className="m-0 text-[12px]">Last known state of meter</p>
                <Switch
                  size=""
                  checkedChildren="off"
                  unCheckedChildren="on"
                  disabled={isCustomerManger}
                />
              </div>
            </div>
            {/* Date meter was assigned */}
            <div className="border flex flex-col justify-between px-4 py-2 h-[130px] rounded-md">
              <h1>Date meter was assigned</h1>
              <div className="flex text-[14px] font-light cursor-pointer items-center p-2 bg-gray-50 rounded-xl w-fit">
                <h1 className=" p-0 m-0 font-semibold pr-4">
                  {!customerData?.body[0]?.meter_assignment_date
                    ? "Not assigned"
                    : moment(
                        customerData?.body[0]?.meter_assignment_date
                      ).format("lll") ?? ""}
                </h1>
                <FcCalendar size={18} />
              </div>
              <div className="mt-2 flex items-center justify-between">
                <p></p>
              </div>
            </div>
            {/* ))} */}
          </div>
        </div>
        {/* Vending table  */}
        <div className="mt-2 rounded-sm bg-white p-2 ">
          <div className="flex items-center mb-4 justify-between">
            <h1>Vending history on meter</h1>
            <div className="">
              {/* <Button
                loading={balanceLoading}
                onClick={handleBalance}
                className="!bg-secondary !border-none !text-white"
                type=""
              >
                Request for balance
              </Button> */}

              <Dropdown overlay={dropdownMenu} trigger={["hover"]}>
                <Button className="" type="">
                  Credit/Balance Operations
                </Button>
              </Dropdown>
              <ExcelExport
                className={"ml-3"}
                excelData={vendData?.purchases ?? []}
                title={"Export Sales"}
                fileName={`Vending_report_${meterid}(${customer})_from_${moment(
                  startdate
                ).format("YYYY-MM-DD")}-to-${moment(enddate).format(
                  "YYYY-MM-DD"
                )}`}
              />
            </div>
          </div>
          <div className="h-[500px]">
            <VendingHistoryTable
              data={vendData?.purchases ?? []}
              loading={vendLoading}
              // setdetails={setdetails}
              // setmodal={setmodal}
            />
          </div>
        </div>

        <div className="mt-2 bg-white p-2 rounded-sm">
          <Segmented
            className="mb-2"
            options={items.map((i) => ({ label: i.label, value: i.id }))}
            value={tabstate}
            onChange={(value) => {
              settabstate(value);
              const selectedItem = items.find((i) => i.id === value);
              if (value !== 1) {
                navigate(selectedItem.link);
              }
            }}
          />
          {tabstate == 1 && <CustomerMeterProfile data={customerData} />}

          {tabstate != 1 && <Outlet />}
        </div>
      </div>
      <div className="h-[200px]"></div>
    </Layout>
  );
};

export default MeterDetails;
